/* Collection of Http Interceptors. Order matters! */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpOrderByInterceptor } from './http-orderby.interceptor';

/** Http interceptor providers in last-to-first order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpOrderByInterceptor, multi: true },
];
